import { ArrowLeftOutlined, FieldTimeOutlined } from '@ant-design/icons';
import { Button, Col } from 'antd';
import { FormattedMessage } from 'react-intl';

import { useArticleDetailContext } from '../ArticleDetailContext';

function TimeLineButton({ isView }) {
  const { timelineVisible, setTimelineVisible } = useArticleDetailContext();
  return (
    <Col>
      <Button
        ghost
        style={{ color: '#BF6800' }}
        disabled={!isView}
        onClick={() => setTimelineVisible((prev) => !prev)}
      >
        {timelineVisible ? (
          <>
            <FormattedMessage id="goBack" />
            <ArrowLeftOutlined />
          </>
        ) : (
          <>
            <FormattedMessage id="article.timeline" />
            <FieldTimeOutlined />
          </>
        )}
      </Button>
    </Col>
  );
}
export default TimeLineButton;
